module.exports = __webpack_public_path__ + "resources/img/img-logo-magic.34f80affc0dc4668cbc8fb46514bc256.png";